import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Image from '../../../../components/Image';
import LockImage from '../../../../components/images/ico-lock-x16.png';

import messages from '../../messages';
import '../../styles.css';

const PremiumFeatureButton = ({ onClick }) => (
  <React.Fragment>
    {/* eslint-disable-next-line */}
    <span styleName="premium-feature" onClick={onClick}>
      <FormattedMessage {...messages.premiumFeatureLink} />
      <Image src={LockImage} styleName="lock-image" aria-hidden="true" />
    </span>
  </React.Fragment>
);

PremiumFeatureButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default PremiumFeatureButton;
